module.exports = {
  SURREALM: {
    PageName: "SURREALM 共學平台",
    ApiErr: "錯誤, code：",
    Login: {
      Login: "登入",
      OpenIDLogin: "OpenID 登入",
      Account: "帳號",
      Password: "密碼",
      PlaceholderEmail: "請輸入信箱",
      PlaceholderPw: "請輸入密碼",
      ForgetPw: "忘記密碼?",
      NoAccount: "還沒有建立帳號嗎?",
      Register: "註冊",
      ReLoginConfirm: "好",
      Warning: "警告",
      Hint: "請點擊以下按鈕並輸入OpenID資訊即可登入共學平台",
      Err: {
        AccountFail: "無此帳號",
        PasswordFail: "密碼錯誤",
        ActiveFail: "您的帳號尚未驗證，請立即至信箱進行驗證",
        ReLoginMsg: "為確保帳號同步更新，將跳轉至登入頁面重新登入",
      }
    },
    Register: {
      PageName: "註冊",
      ConfirmPw: "確認密碼",
      HasAccount: "已經有帳號了嗎?",
      Login: "登入",
      PlaceholderPwAgain: "再次輸入密碼",
      ErrMsg: {
        Account: "信箱格式錯誤，請重新輸入",
        Password: "密碼需為英文+數字組合,長度為6-12個字",
        PasswordAgain: "確認密碼不符，請重新輸入",
        AccPwNull: "請輸入帳號密碼，謝謝。"
      }
    },
    RegisterDone: {
      PageName: "註冊成功",
      Content: "我們已經寄送一封帳號驗證信至您的信箱",
      ReMail: "重新寄送",
      CantReceiveMail: "一直收不到信嗎?",
      ContantUs: "聯絡我們",
    },
    Active: {
      PageName: "驗證成功",
      Content: "現在您可以開始使用SURREALM 共學平台<br/>畫面將自動登入至平台",
      LoginNow: "立即登入"
    },
    ForgetPw: {
      PageName: "忘記密碼",
      SubTitle: "請輸入您申請的帳號信箱以重設密碼",
      PlaceholderEmail: "請輸入信箱",
      SendMail: "寄送",
      RememberPw: "想起密碼了嗎?",
      Login: "登入"
    },
    ForgetPwDone: {
      PageName: "寄送完成",
      Content: "我們已將重設密碼連結寄送至您的信箱",
      ReMail: "重新寄送",
      CantReceiveMail: "一直收不到信嗎?",
      ContantUs: "聯絡我們",
    },
    ResetPW: {
      PageName: "重設密碼",
      NewPW: "新密碼",
      Reset: "送出",
      ErrMsg: {
        PwNull: ""
      }
    },
    ResetPWDone: {
      PageName: "設定完成",
      Content: "已成功設定新密碼，請重新登入",
      Login: "登入"
    },
    Header: {
      Logout: "登出"
    },
    Menu: {
      Home: "首頁",
      Lecture: "課程總覽",
      LectureOwn: "我的課程",
      LectureHistory: "授課歷程",
      ClientLectureHistory: "上課歷程",
      Student: "學生管理",
      Files: "上課資料",
      AccountInfo: "個人設定",
      System: "訊息推播",
      Hint: "操作提示",
    },
    Guide: {
      WelcomeTitle: "歡迎來到SURREALM共學平台<br />我們將幫助您快速熟悉使用",
      NextStep: "下一頁",
      PreStep: "上一頁",
      KeyinTitle: "請輸入個人資訊",
      KeyinHint: "*為必填",
      Name: "真實姓名*",
      Gender: "性別*",
      Birth: "生日*",
      Nickname: "顯示名稱*",
      School: "任職學校*",
      Subject: "任教科目*",
      OpenID: "OPEN ID",
      Phone: "手機",
      finishTitle: "填寫完成，現在您可以開始體驗",
      finishContent: "若想修改個人資訊，稍後您可以在個人設定中進行修改",
      startUse: "開始體驗",
      NameHint: "注意:真實姓名無法修改請確實填寫",
      StudentNameHint: "注意:真實姓名已由老師填寫完成",
      Placeholder: {
        Name: "請輸入姓名",
        Gender: "請選擇",
        Birth: "生日",
        Nickname: "顯示名稱可於個人設定進行修改",
        School: "請輸入學校名稱",
        Subject: "請輸入科目名稱",
        OpenID: "選填",
        Phone: "選填",
      },
      Err: {
        NameEmpty: "請輸入姓名, 再點選下一頁",
        SexEmpty: "請選擇性別, 再點選下一頁",
        BirthdayEmpty: "請選擇生日, 再點選下一頁",
        NicknameEmpty: "請填寫暱稱, 再點選下一頁",
        SchoolEmpty: "請填寫學校, 再點選下一頁",
        SubjectEmpty: "請填寫科目, 再點選下一頁",
      }
    },
    ClientGuide: {
      Subject: "喜愛科目",
      School: "就讀學校*",
    },
    AccountInfo: {
      PageName: "個人設定",
      EditInfo: "編輯資訊",
      ChangePW: "變更密碼",
      BtnCancel: "取消",
      BtnSave: "儲存",
      OldPW: "舊密碼",
      NewPW: "新密碼",
      NewPWAgain: "新密碼確認",
      ChangePWOK: "密碼修改完成",
      PlaceholderOldPW: "請輸入舊密碼",
      PlaceholderNewPW: "請輸入新密碼",
      PlaceholderNewPWAgain: "再次輸入新密碼",
      Option: {
        Null: "請選擇",
        Male: "男",
        Female: "女",
        Other: "其他",
      },
      Err: {
        SexEmpty: "請選擇性別, 再儲存",
        BirthdayEmpty: "請選擇生日, 再儲存",
        NicknameEmpty: "請填寫暱稱, 再儲存",
        SchoolEmpty: "請填寫學校, 再儲存",
        SubjectEmpty: "請填寫科目, 再儲存",
      }
    },
    LectureOwn: {
      PageName: "我的課程",
      AddLecture: "我要開課",
      AddDialogTitle1: "您想要開什麼課程呢?",
      AddDialogTitle2: "選擇課堂要使用的模型!",
      AddDialogTitle3: "邀請學生來參與您的課程吧!",
      AddDialogTitle4: "上傳您的資料，豐富您的課程",
      AddDialogTitle5: "就快完成了!!",
      AddDialogTitle6: "最後一步了!!",
      LectureName: "課程名稱",
      LectureDate: "課程日期",
      LectureStartTime: "開始時間",
      LectureEndTime: "結束時間",
      LectureType: "教室類型",
      LectureAuth: "課程權限",
      LectureDes: "課程說明",
      LectureCode: "課程代碼",
      LectureNum: "人數上限",
      PeopleMax: "最大容納人數",
      NextStep: "下一步",
      PreStep: "上一步",
      Release: "發布",
      SelectModel: "選擇模型",
      SelectModelTitle: "您最多可以添加六個模型在課堂中使用<br/>備課完成後，可以到課程頁面變更模型",
      TagFilter: "標籤篩選",
      SelectStudent: "選擇學生",
      SelectALL: "全選",
      RemoveAll: "清除選取",
      SelectedNumber: "已選取學生人數",
      Upload: "上傳",
      UpLinkStep1: "1.貼上雲端路徑連結",
      UpLinkStep2: "2.幫資料命名",
      UpLinkStep3: "3.點擊上傳",
      UpLinkTitleName: "現有資料名稱",
      UpLinkTitleDate: "上傳日期",
      UpLinkTitleDel: "刪除",
      LastStepTitle: "確認課程資訊無誤後，請點擊「發布」，系統將會通知所有受邀學生",
      BtnBack: "返回",
      EditLecture: "修改課程",
      SendPost: "發送公告",
      SetExam: "測驗出題",
      StudentList: "學生名單",
      Warning: "警告",
      DelMsg: "刪除的課程將無法復原, 確定要刪除嗎?",
      DelLeftBtn: "取消",
      DelRightBtn: "刪除",
      LectureSoon: "近期課程(3日內)",
      LectureLater: "即將到來的課程",
      NoLectureSoon: "3日內無課程",
      NoLectureLater: "3日後已無課程",
      Public: "公開",
      Private: "非公開",
      NeedAuth: "需審核",
      ModelAddDone: "{Name} 已新增",
      ModelDelDone: "{Name} 已刪除",
      DelModel: "移除",
      Placeholder: {
        Name: "替您的課程取個名稱吧!",
        Des: "請至少輸入10個字",
        StudentName: "請輸入學生名稱",
        ModelName: "請輸入模型名稱",
        Link: "請貼上雲端路徑連結",
        LinkName: "請輸入資料名稱",
      },
      Err: {
        Name: "請輸入課程名稱",
        Date: "請選擇授課日期",
        Time: "請選擇授課時間",
        Type: "請選擇課程類型",
        Auth: "請選擇課程權限",
        Des: "課程說明請至少輸入10個字",
        StudentLength: "請選擇學生",
        MaxStudent: "已達人數上限",
        AddRepeat: "重複新增",
        OverMax: "因更改教室導致學生人數超過教室上限, 請移除學生",
        NullImage: "請幫課程上傳一張圖片",
        StartTimeErr: "開始時間不得早於現在",
        EndTimeErr: "結束時間不得早於開始時間",
        NullModel: "找不到與 \"{keyin}\" 相關的模型",
        ModelMaxLimit: "模型數量已達上限 {Num} 個",
        ModelRepear: "模型不可重複",
        PlzSelectModel: "請選擇模型",
      }
    },
    CropperView: {
      Title: "系統已幫您預設課程預覽圖<br/>您也可以自行上傳",
      Cut: "裁切",
      Cancel: "取消",
      Upload: "上傳圖片",
    },
    LectureItem: {
      ShowLectureCode: "顯示課程碼",
      EditLecture: "修改課程",
      DelLecture: "刪除課程",
    },
    LectureCode: {
      Code: "課程邀請碼",
      Copy: "複製",
      Copied: "已複製"
    },
    LectureHistory: {
      PageName: "授課歷程",
      StartDate: "開始日期",
      EndDate: "結束日期",
      Search: "查詢",
      Date: "授課日期",
      Time: "時數(分)",
      LectureName: "已結束課程名稱",
      Attend: "學生出席統計",
      Video: "上傳影片",
      AddVideo: "新增影片",
      ReStart: "再次開課",
      Record: "成績單",
      btnBack: "返回",
      TeacherName: '授課教師',
      AttendAndPeopleNumber: "實到 / 應到人數"
    },
    ClientLectureHistory: {
      PageName: "上課歷程",
      Date: "上課日期",
      Time: "時數(分)",
      Attend: "有否出席",
      AttendTrue: "有",
      AttendFalse: "否",
      Video: "課程影片",
    },
    Files: {
      PageName: "上課資料",
      Warning: "警告",
      DelMsg: "上課資料為跨課程使用，刪除的連結將無法復原，確定要刪除嗎？",
      DelLeftBtn: "取消",
      DelRightBtn: "刪除",
    },
    Systems: {
      PageName: "系統公告",
      LogContent: "已收到系統公告",
      LogDateTime: "日期",
      LectureLog: "課程公告",
      LectureContent: "已發送課程公告",
      ClientLectureContent: "已收到課程公告",
      Teacher: {
        Create_Lecture: "您發布了課程",
        Modify_Lecture: "您已修改了課程",
        Share_Video: "您已為此課程分享了一支影片",
        Modify_Video: "您已修改了此課程的影片",
      },
      Student: {
        Create_Lecture: "您已受邀參加此課程",
        Modify_Lecture: "此課程有部分修改",
        Share_Video: "老師已為此課程分享了一支影片",
        Modify_Video: "此課程的影片有部分修改",
      }
    },
    StudentManager: {
      PageName: "學生管理",
      AddStudent: "個別新增",
      EditStudent: "修改",
      ImportStudentExample: "匯入範例下載",
      ImportStudent: "批次匯入",
      TagFilter: "標籤篩選",
      TagEdit: "編輯標籤",
      SelectStudent: "選擇學生",
      SelectAll: "全選",
      RemoveAll: "清除選取",
      ToolList: "工具列表",
      StudentTagEdit: "變更學生標籤",
      StudentDel: "刪除學生",
      StudentName: "學生姓名",
      StudentNickName: "暱稱",
      StudentSchool: "就讀學校",
      StudentEmail: "帳號",
      StudentTag: "標籤",
      Err: {
        FilterNotEmpty: "請先刪除關鍵字內的學生姓名,以完整顯示選擇的學生,謝謝",
        EmptySelect: "請先選擇學生,謝謝",
        RepeatAdd: "無法重複新增,謝謝",
        InvalidAcc: "無效帳號，請重新確認",
        ImportInvalidAcc: "內含無效帳號，請重新確認",
      },
      Placeholder: {
        Email: "請輸入信箱",
        Name: "請輸入學生姓名",
        Nickname: "請輸入學生暱稱"
      }
    },
    Tags: {
      TagTitle: "幫學生設定標籤",
      TagAll: "全部",
      TagEdit: "編輯標籤",
      Warning: "警告",
      DelTagMsg: "刪除的標籤將無法復原, 確定要刪除嗎?",
      DelMsg: "選取的學生將從學生管理名單內刪除，是否確定繼續 ? ",
      DelLeftBtn: "取消",
      DelRightBtn: "確定",
      DelDone: "已刪除",
      EditOK: "修改完畢",
      Add: "新增",
      Placeholder: {
        Name: "請輸入標籤名稱"
      },
      Err: {
        TagNameRepeat: "已經有相同名稱的標籤",
        TagNameEmpty: "請輸入標籤名稱",
      }
    },
    Post: {
      Title: "發送公告",
      Content: "公告內容",
      Cancel: "取消",
      Send: "發送",
      Sent: "已送出公告",
      NeverRead: "未讀",
      Placeholder: {
        TenWord: "請至少輸入10個字"
      },
      Err: {
        MaxNum: "公告不得超過300字"
      },
    },
    Exam: {
      Title: "專科測驗",
      Time: "每題答題時間",
      TotalTime: "總答題時間",
      Second: "秒",
      Select: "選擇題",
      SingleSelect: "單選",
      MultiSelect: "複選",
      SelectAnswer: "選擇答案",
      DelAnswer: "刪除",
      ExamDone: "考題已更新",
      AddExam: "新增考題",
      Placeholder: {
        Title: "請輸入文字"
      },
      Err: {
        AnswerRepeat: "答案已重複，請選擇其他答案",
        TitleEmpty: "第{Num}題, 請輸入題目",
        AnswerErr: "第{Num}題為複選題, 複選題請選擇2~3個答案",
        AnswerEmpty: "第{Num}題未選擇任何答案",
      }
    },
    Video: {
      Title: "時間戳記",
      NoVideo: "此課程沒有任何影片"
    },
    Hint: {
      Title: "操作提示",
      SubTitle1: "歡迎使用SURREALM，請依照提示完成您的第一堂課吧!",
      Desc1_1: "請先點擊左側選單\"學生管理\"",
      Desc1_2: "在學生管理頁面上方選擇要<br/>\"個別新增\"或\"批次匯入\"學員名單",
      Desc2_1: "完成學生管理後<br/>請點擊左側選單\"課程總覽\"",
      Desc2_2: "在頁面上方點擊\"我要備課\"<br/>順著步驟即可完成開課",
    },
    QA: {
      QAFile: "資料必須為有效的「網頁」格式。<br>如該資料為雲端硬碟內的連結，請將權限設為公開，才能正常開啟。",
      QAComfirm: "確認",
    }
  }
};
